import { createTheme as createMuiTheme, type PaletteOptions, type Direction, type PaletteMode } from '@mui/material';
import { type Palette, type PaletteColor } from '@mui/material/styles';
import { baseThemeOptions } from './base-theme-options';
import { darkThemeOptions } from './dark-theme-options';
import { lightThemeOptions } from './light-theme-options';

/** Palette entries with main/light/dark shades: `primary`, `success`, … */
export type PaletteColorKey = { [K in keyof Palette]: Palette[K] extends PaletteColor ? K : never }[keyof Palette];

type CreateThemeProps = { direction?: Direction; paletteMode?: PaletteMode };

export const createTheme = ({ direction, paletteMode }: CreateThemeProps = {}) => {
  let extraOptions: Record<'palette', PaletteOptions> | undefined;
  if (paletteMode !== undefined) {
    // The scheme's own palette: a bare `{ mode }` would replace it with MUI's defaults.
    const { palette } = paletteMode === 'dark' ? darkThemeOptions : lightThemeOptions;
    extraOptions = { palette: { ...palette, mode: paletteMode } };
  }
  return createMuiTheme({
    ...baseThemeOptions,
    ...extraOptions,
    direction,
    colorSchemes: {
      light: paletteMode === 'dark' ? false : lightThemeOptions,
      dark: paletteMode === 'light' ? false : darkThemeOptions,
    },
  });
};
